import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { POPUP_ALERT_TYPE } from './vg-popup-alert';

@Component({
  selector: 'vg-popup-alert',
  templateUrl: './vg-popup-alert.component.html',
  styleUrls: ['./vg-popup-alert.component.scss']
})
export class VgPopupAlertComponent implements OnInit {
  @Input() type: POPUP_ALERT_TYPE;
  @Input() template: TemplateRef<any>;
  @Input() message: string;
  @Input() class: string;

  public POPUP_ALERT_TYPE = POPUP_ALERT_TYPE;

  constructor() { }

  ngOnInit() {
  }

}
